module.exports = __webpack_public_path__ + "static/media/TasklyUserFlow.f62006f1.png";